/**
 * Import from node_modules
 */
import 'bootstrap/js/src/scrollspy';

/**
 * Import site scripts
 */
import AOS from 'aos';
import SkipLinkFocusFix from './site/skip-link-focus-fix';
import Menu from './site/menu';
import Sliders from './site/sliders';
import ScrollTo from './site/scrollTo';
import Styleguide from './site/styleguide';
import FormHelpers from './site/formHelpers';
import LazyLoading from './site/lazyLoad';
import OpenLoginPopup from './site/openLoginPopup';
import MoveElements from './site/moveElements';
import counterNumber from './site/counterNumber';
import Animations from './site/animations';
import ScrollToSection from './site/scrollToSection';
import loadMore from './site/loadMore';
import SetPassword from './site/setPassword';
import ResetPassword from './site/resetPassword';
import StoreMap from './site/storeMap';
import OpenMapPopup from './site/openMapPopup';
import FindUsSavingData from './site/findUsSavingData';

/**
 * Init site scripts
 */
jQuery(function() {
	SkipLinkFocusFix.init();
	Styleguide.init();
	Menu.init();
	Sliders.init();
	ScrollTo.init();
	FormHelpers.init();
	LazyLoading.init();
	OpenLoginPopup.init();
	MoveElements.init();
	counterNumber.init();
	AOS.init({
		once: true,
		offset: -20,
		duration: 500,
	});
	Animations.init();
	ScrollToSection.init();
	loadMore.init();
	SetPassword.init();
	ResetPassword.init();
	StoreMap.init();
	OpenMapPopup.init();
	FindUsSavingData.init();
});
